export const NoAccess = () => {
	return <div className="container">You cannot access this page.</div>;
};
